import { ReturnBearZod } from "@redotech/redo-model/return";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import Printer from "@redotech/redo-web/arbiter-icon/printer.svg";
import QrCode from "@redotech/redo-web/arbiter-icon/qr-code-01.svg";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { ReturnBearLocationsButton } from "./return-bear-locations-button";

export const ReturnBearLabelButtons = memo(function ReturnBearLabelButtons({
  returnBearDetails,
  returnId,
  autoOpen = false,
}: {
  returnBearDetails: ReturnBearZod;
  returnId: string;
  autoOpen?: boolean;
}) {
  const qrCodeUri = returnBearDetails.qrCodeUri;
  const labelUri = returnBearDetails.shippingInfo?.shippingLabelUrl;

  return (
    <>
      {!!qrCodeUri && (
        <>
          <Flex>
            <RedoButton
              hierarchy="secondary"
              IconLeading={QrCode}
              onClick={() => window.open(qrCodeUri, "_blank")}
              text="QR code"
            />
          </Flex>
          <ReturnBearLocationsButton autoOpen={autoOpen} returnId={returnId} />
        </>
      )}

      {!!labelUri && (
        <Flex>
          <RedoButton
            hierarchy="secondary"
            IconLeading={Printer}
            onClick={() => window.open(labelUri, "_blank")}
            text="Print label"
          />
        </Flex>
      )}
    </>
  );
});
